(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mojokoe-conversion-layer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mojoAtelierTranslations = null;

    function atelierTranslations() {
      if (mojoAtelierTranslations) return mojoAtelierTranslations;
      var source = document.querySelector('[data-mojo-atelier-translations]');
      if (!source) return {};
      try {
        mojoAtelierTranslations = JSON.parse(source.textContent || '{}');
      } catch (error) {
        mojoAtelierTranslations = {};
      }
      return mojoAtelierTranslations;
    }

    function atelierCopy(key, replacements) {
      var copy = String(atelierTranslations()[key] || '');
      Object.keys(replacements || {}).forEach(function (token) {
        copy = copy.split('__' + token.toUpperCase() + '__').join(String(replacements[token]));
      });
      return copy;
    }

    function setDisplayLabel(choice, compact) {
      if (!choice) return '';
      if (compact) return choice.dataset.mojoShortLabel || choice.dataset.mojoDisplayLabel || choice.value.split(' — ')[0];
      return choice.dataset.mojoDisplayLabel || choice.value;
    }

    function mountOrderAtelier(root) {
      root.querySelectorAll('[data-mojo-order-atelier]').forEach(function (panel) {
        var mainProduct = document.querySelector('.shopify-section--main-product');
        if (!mainProduct) return;

        var infoList = mainProduct.querySelector('.product-info__block-list');
        var productLayout = mainProduct.querySelector('.product');
        var productForm = mainProduct.querySelector('form[action*="/cart/add"]');
        if (!infoList || !productForm) return;

        var formId = productForm.getAttribute('id');
        if (!formId) {
          formId = 'mojo-product-form-' + Math.random().toString(36).slice(2, 9);
          productForm.setAttribute('id', formId);
        }

        panel.querySelectorAll('input, select, textarea').forEach(function (field) {
          field.setAttribute('form', formId);
        });

        if (panel.hasAttribute('data-mojo-compact-protector')) {
          if (panel.parentElement !== infoList) {
            var compactQuantity = infoList.querySelector('[data-block-type="quantity-selector"]');
            var compactBuyButtons = infoList.querySelector('[data-block-type="buy-buttons"]');
            var compactAnchor = compactQuantity || compactBuyButtons;
            while (compactAnchor && compactAnchor.parentElement !== infoList) {
              compactAnchor = compactAnchor.parentElement;
            }
            infoList.insertBefore(panel, compactAnchor || null);
          }
          enhanceCompactProtector(panel, mainProduct, productForm);
        } else if (productLayout && panel.parentElement !== productLayout) {
          productLayout.appendChild(panel);
        } else if (!productLayout && panel.parentElement !== infoList) {
          var quantity = infoList.querySelector('[data-block-type="quantity-selector"]');
          var buyButtons = infoList.querySelector('[data-block-type="buy-buttons"]');
          infoList.insertBefore(panel, quantity || buyButtons || null);
        }

        var customApproval = panel.querySelector('[data-mojo-native-custom-approval]');
        if (customApproval && !customApproval.dataset.bound) {
          customApproval.dataset.bound = 'true';
          productForm.addEventListener('variant:change', function (event) {
            var variant = event.detail && event.detail.variant;
            var nativeCustom = Boolean(variant && /\bcustom\b/i.test(variant.title || (variant.options || []).join(' ')));
            customApproval.dataset.nativeCustom = nativeCustom ? 'true' : 'false';
            customApproval.hidden = !nativeCustom && customApproval.dataset.secondCustom !== 'true';
          });
        }
        panel.classList.add('is-ready');
      });
    }

    function enhanceCompactProtector(atelier, mainProduct, productForm) {
      if (atelier.dataset.mojoProtectorEnhanced === 'true') return;
      var customPanel = atelier.querySelector('[data-mojo-protector-custom-size]');
      if (!customPanel) return;
      atelier.dataset.mojoProtectorEnhanced = 'true';
      var dimensions = Array.prototype.slice.call(customPanel.querySelectorAll('[data-mojo-protector-custom-dimension]'));

      function syncCustomFields(event) {
        var variant = event && event.detail && event.detail.variant;
        if (!variant) {
          var variantData = mainProduct.querySelector('variant-picker[context="main_product"] script[data-variant]');
          try {
            variant = JSON.parse(variantData ? variantData.textContent : '{}');
          } catch (error) {
            variant = {};
          }
        }
        var values = Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3];
        var isCustom = values.some(function (value) { return /\bcustom\b/i.test(String(value || '')); });
        customPanel.hidden = !isCustom;
        dimensions.forEach(function (input) {
          input.disabled = !isCustom;
          input.required = isCustom;
          input.setAttribute('aria-required', isCustom ? 'true' : 'false');
        });
      }

      productForm.addEventListener('variant:change', syncCustomFields);
      syncCustomFields();
    }

    function enhanceAtelierSteps(root) {
      root.querySelectorAll('[data-mojo-order-atelier]').forEach(function (atelier) {
        if (atelier.dataset.mojoStepsEnhanced === 'true') return;
        atelier.dataset.mojoStepsEnhanced = 'true';

        var triggers = Array.prototype.slice.call(atelier.querySelectorAll('[data-mojo-stage-trigger]'));
        var panels = Array.prototype.slice.call(atelier.querySelectorAll('[data-mojo-stage-panel]'));
        if (!triggers.length || !panels.length) return;

        function activateStage(stageName, moveFocus) {
          triggers.forEach(function (trigger) {
            var selected = trigger.dataset.mojoStageTrigger === stageName;
            trigger.setAttribute('aria-selected', selected ? 'true' : 'false');
            trigger.tabIndex = selected ? 0 : -1;
          });

          panels.forEach(function (stagePanel) {
            stagePanel.classList.toggle('is-active', stagePanel.dataset.mojoStagePanel === stageName);
          });

          var activeTrigger = triggers.find(function (trigger) {
            return trigger.dataset.mojoStageTrigger === stageName;
          });
          if (moveFocus && activeTrigger) activeTrigger.focus();
        }

        triggers.forEach(function (trigger, index) {
          trigger.addEventListener('click', function () {
            activateStage(trigger.dataset.mojoStageTrigger, false);
          });

          trigger.addEventListener('keydown', function (event) {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            event.preventDefault();
            var direction = event.key === 'ArrowRight' ? 1 : -1;
            var nextIndex = (index + direction + triggers.length) % triggers.length;
            activateStage(triggers[nextIndex].dataset.mojoStageTrigger, true);
          });
        });

        var initialTrigger = triggers.find(function (trigger) {
          return trigger.getAttribute('aria-selected') === 'true';
        }) || triggers[0];

        if (initialTrigger) {
          activateStage(initialTrigger.dataset.mojoStageTrigger, false);
        }

        atelier.addEventListener('invalid', function (event) {
          var invalidPanel = event.target.closest('[data-mojo-stage-panel]');
          if (invalidPanel) activateStage(invalidPanel.dataset.mojoStagePanel, false);
        }, true);

        var note = atelier.querySelector('[data-mojo-order-note]');
        var noteSummary = atelier.querySelector('[data-mojo-stage-summary="notes"]');
        if (note && noteSummary) {
          note.addEventListener('input', function () {
            noteSummary.textContent = note.value.trim() ? atelierCopy('noteAdded') : (note.required ? atelierCopy('required') : atelierCopy('optional'));
          });
        }

        var protectorCustomPanel = atelier.querySelector('[data-mojo-protector-custom-size]');
        if (protectorCustomPanel) {
          var protectorCustomDimensions = Array.prototype.slice.call(protectorCustomPanel.querySelectorAll('[data-mojo-protector-custom-dimension]'));
          var mainProduct = document.querySelector('.shopify-section--main-product');

          function protectorCustomIsSelected() {
            if (!mainProduct) return false;
            var selectedValues = Array.prototype.slice.call(mainProduct.querySelectorAll('select option:checked, input[type="radio"]:checked'));
            return selectedValues.some(function (field) {
              var label = field.closest('label');
              var selectedCopy = [field.value, field.textContent, field.getAttribute('aria-label'), label && label.textContent].filter(Boolean).join(' ');
              return selectedCopy.toLowerCase().indexOf('custom') !== -1;
            });
          }

          function syncProtectorCustomFields() {
            var isCustom = protectorCustomIsSelected();
            protectorCustomPanel.hidden = !isCustom;
            protectorCustomDimensions.forEach(function (input) {
              input.disabled = !isCustom;
              input.required = isCustom;
              if (!isCustom) input.value = '';
            });
            if (noteSummary && note && !note.value.trim()) noteSummary.textContent = isCustom ? atelierCopy('sizeRequired') : atelierCopy('optional');
          }

          if (mainProduct) mainProduct.addEventListener('change', syncProtectorCustomFields, true);
          document.addEventListener('variant:change', syncProtectorCustomFields);
          syncProtectorCustomFields();
        }
      });
    }

    function enhanceSetComposers(root) {
      root.querySelectorAll('[data-mojo-set-composer]').forEach(function (composer) {
        if (composer.dataset.mojoEnhanced === 'true') return;
        composer.dataset.mojoEnhanced = 'true';

        var panel = composer.closest('[data-mojo-order-atelier]');
        var choices = Array.prototype.slice.call(composer.querySelectorAll('[data-mojo-set-choice]'));
        var status = composer.querySelector('[data-mojo-set-status]');
        var note = panel && panel.querySelector('[data-mojo-order-note]');
        var noteState = panel && panel.querySelector('[data-mojo-note-state]');
        var stageSummary = panel && panel.querySelector('[data-mojo-stage-summary="configuration"]');
        var secondSheet = panel && panel.querySelector('[data-mojo-second-sheet]');
        var secondSheetSize = secondSheet && secondSheet.querySelector('[data-mojo-second-sheet-size]');
        var secondSheetMotif = secondSheet && secondSheet.querySelector('[data-mojo-second-sheet-motif]');

        if (secondSheetMotif) {
          var motifNames = [];
          try {
            motifNames = JSON.parse(secondSheetMotif.dataset.mojoSecondSheetMotifs || '[]');
          } catch (error) {
            motifNames = [];
          }
          if (Array.isArray(motifNames)) {
            motifNames.filter(function (name, index, names) {
              return typeof name === 'string' && name.trim() && names.indexOf(name) === index;
            }).forEach(function (name) {
              var option = document.createElement('option');
              option.value = name;
              option.textContent = name;
              secondSheetMotif.appendChild(option);
            });
          }
        }

        function isTwoSheetSet(choice) {
          return Boolean(choice && (choice.hasAttribute('data-mojo-second-sheet-choice') || /^(?:2|dua)\s+sprei set\b/i.test(String(choice.value || ''))));
        }

        function secondSheetNeedsNote() {
          return Boolean(secondSheetSize && !secondSheetSize.disabled && /^custom\b/i.test(secondSheetSize.value));
        }

        function syncNoteRequirement(requiresSecondSet) {
          if (!note) return;

          var legacyChoice = requiresSecondSet && !secondSheetSize;
          var customSecondSize = requiresSecondSet && secondSheetNeedsNote();
          var noteRequired = legacyChoice || customSecondSize;
          var secondCustomApproval = panel.querySelector('[data-mojo-second-custom-approval]');
          if (secondCustomApproval) secondCustomApproval.hidden = !customSecondSize;
          var nativeCustomApproval = panel.querySelector('[data-mojo-native-custom-approval]');
          if (nativeCustomApproval) {
            nativeCustomApproval.dataset.secondCustom = legacyChoice ? 'true' : 'false';
            nativeCustomApproval.hidden = nativeCustomApproval.dataset.nativeCustom !== 'true' && !legacyChoice;
          }

          note.required = noteRequired;
          note.setAttribute('aria-required', noteRequired ? 'true' : 'false');
          var noteSummary = panel.querySelector('[data-mojo-stage-summary="notes"]');
          if (noteSummary) {
            noteSummary.textContent = note.value.trim() ? atelierCopy('noteAdded') : (noteRequired ? atelierCopy('required') : atelierCopy('optional'));
          }
          note.placeholder = customSecondSize
            ? atelierCopy('requiredCustomSecond')
            : legacyChoice
              ? atelierCopy('requiredTwoSets')
              : atelierCopy('orderNotePlaceholder');

          if (noteState) {
            noteState.textContent = noteRequired ? atelierCopy('requiredForCustom') : atelierCopy('optionalLowercase');
          }
        }

        function syncSetChoice() {
          var selected = choices.find(function (choice) { return choice.checked; });
          var requiresSecondSet = isTwoSheetSet(selected);

          if (status) {
            status.textContent = selected ? atelierCopy('savedSelection') + ': ' + setDisplayLabel(selected) : atelierCopy('noConfiguration');
          }

          if (stageSummary) {
            stageSummary.textContent = selected ? setDisplayLabel(selected, true) : atelierCopy('notSelected');
          }

          if (secondSheet) {
            secondSheet.hidden = !requiresSecondSet;
          }
          if (secondSheetSize) {
            secondSheetSize.disabled = !requiresSecondSet;
            if (!requiresSecondSet) secondSheetSize.value = 'Sama dengan ukuran pertama';
          }
          if (secondSheetMotif) {
            secondSheetMotif.disabled = !requiresSecondSet;
            if (!requiresSecondSet) secondSheetMotif.selectedIndex = 0;
          }

          syncNoteRequirement(requiresSecondSet);
        }

        choices.forEach(function (choice) {
          choice.addEventListener('change', syncSetChoice);
        });
        if (secondSheetSize) secondSheetSize.addEventListener('change', syncSetChoice);
        syncSetChoice();
      });
    }

    function enhanceFabricAtlases(root) {
      root.querySelectorAll('.mojo-fabric-library').forEach(function (library) {
        if (library.dataset.mojoEnhanced === 'true') return;
        library.dataset.mojoEnhanced = 'true';

        var input = library.querySelector('[data-mojo-fabric-input]');
        var status = library.querySelector('[data-mojo-fabric-status]');
        var atelier = library.closest('[data-mojo-order-atelier]');
        var stageSummary = atelier && atelier.querySelector('[data-mojo-stage-summary="fabric"]');
        var choices = Array.prototype.slice.call(library.querySelectorAll('[data-mojo-fabric-choice]'));
        if (!input) return;

        function markSelection(value) {
          choices.forEach(function (choice) {
            choice.setAttribute('aria-pressed', choice.dataset.fabricValue === value ? 'true' : 'false');
          });
          if (status) {
            status.textContent = value
              ? atelierCopy('savedSelection') + ': ' + value + '. ' + atelierCopy('screenColourNote')
              : atelierCopy('noColour');
          }
          if (stageSummary) {
            stageSummary.textContent = value ? value.replace(/^.*? — /, '') : atelierCopy('notSelected');
          }
        }

        var maternity = library.hasAttribute('data-mojo-maternity-cover')
          ? enhanceMaternityFabric(library, input, choices, markSelection)
          : null;

        choices.forEach(function (choice) {
          choice.addEventListener('click', function () {
            if (maternity && !maternity.allows(choice.dataset.fabricValue)) return;
            input.value = choice.dataset.fabricValue;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
            markSelection(input.value);
          });
        });

        input.addEventListener('input', function () {
          if (maternity) maternity.sync();
          markSelection(input.value);
        });
        markSelection(input.value);
      });
    }

    // Maternity covers keep native material/shape pricing; only the matching atlas is selectable.
    function enhanceMaternityFabric(library, input, choices, markSelection) {
      var catalog;
      try {
        catalog = JSON.parse(library.querySelector('[data-mojo-maternity-variants]').textContent);
      } catch (error) {
        catalog = {};
      }
      var atlases = Array.prototype.slice.call(library.querySelectorAll('[data-mojo-maternity-atlas]'));
      var family = '';
      var changing = false;
      var handle = 'mojokoe-cover-maternity-pregnancy-body-pillow-sarung-bantal-ibu-hamil';

      function nativePicker() {
        return document.querySelector('variant-picker[context="main_product"][handle="' + handle + '"]');
      }

      function nativeForm() {
        var picker = nativePicker();
        return picker && document.getElementById(picker.getAttribute('form-id'));
      }

      function allows(value) {
        return !changing && Boolean(family) && choices.some(function (choice) {
          var atlas = choice.closest('[data-mojo-maternity-atlas]');
          return atlas && atlas.dataset.mojoMaternityAtlas === family && choice.dataset.fabricValue === value;
        });
      }

      function sync(variant) {
        var picker = nativePicker();
        var form = nativeForm();
        // Prestige updates this native ID before its rerender/variant events.
        // Read the field, not form.id (which is clobbered by name="id").
        var nativeId = form && form.querySelector('[name="id"]');
        family = catalog[String(nativeId ? nativeId.value : '')] || '';
        if (form) input.setAttribute('form', form.getAttribute('id'));
        atlases.forEach(function (atlas) {
          var active = Boolean(family) && atlas.dataset.mojoMaternityAtlas === family;
          atlas.hidden = !active;
          atlas.disabled = !active || changing;
          var details = atlas.querySelector('details');
          if (details) details.open = active;
        });
        choices.forEach(function (choice) {
          var atlas = choice.closest('[data-mojo-maternity-atlas]');
          choice.disabled = changing || !family || !atlas || atlas.dataset.mojoMaternityAtlas !== family;
        });
        // This resets only an incompatible in-progress choice, never catalog colors or stock.
        if (!changing && input.value && !allows(input.value)) input.value = '';
        input.dataset.mojoMaternityValid = allows(input.value) ? 'true' : 'false';
        library.setAttribute('aria-busy', changing ? 'true' : 'false');
        markSelection(input.value);
      }

      document.addEventListener('change', function (event) {
        if (!library.isConnected) return;
        var picker = nativePicker();
        if (!picker || !picker.contains(event.target) || !event.target.matches('input, select')) return;
        changing = true;
        sync();
      }, true);

      document.addEventListener('variant:change', function (event) {
        if (!library.isConnected || event.target !== nativeForm()) return;
        changing = false;
        sync(event.detail && event.detail.variant);
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });

      document.addEventListener('submit', function (event) {
        if (!library.isConnected || event.target !== nativeForm()) return;
        sync();
        if (allows(input.value)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var atelier = library.closest('[data-mojo-order-atelier]');
        var trigger = atelier && atelier.querySelector('[data-mojo-stage-trigger="fabric"]');
        if (trigger) trigger.click();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        var firstChoice = choices.find(function (choice) { return !choice.disabled; });
        if (firstChoice) firstChoice.focus({ preventScroll: true });
        library.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);

      sync();
      return { allows: allows, sync: sync };
    }

    function enhanceDeGrandeComposers(root) {
      root.querySelectorAll('[data-mojo-degrande-composer], [data-mojo-dobby-composer]').forEach(function (composer) {
        if (composer.dataset.mojoEnhanced === 'true') return;
        composer.dataset.mojoEnhanced = 'true';

        var isDobby = composer.hasAttribute('data-mojo-dobby-composer');
        var prefix = isDobby ? 'dobby' : 'degrande';
        var firstRole = isDobby ? 'primary' : 'base';
        var secondRole = isDobby ? 'reverse' : 'accent';
        var valueAttribute = 'data-' + prefix + '-value';
        var openAttribute = 'data-' + prefix + '-open';
        var hexAttribute = 'data-' + prefix + '-hex';
        var atelier = composer.closest('[data-mojo-order-atelier]');
        var firstSelect = composer.querySelector('[' + valueAttribute + '="' + firstRole + '"]');
        var secondSelect = composer.querySelector('[' + valueAttribute + '="' + secondRole + '"]');
        var dialog = composer.querySelector('[data-' + prefix + '-dialog]');
        var dialogTitle = composer.querySelector('[data-' + prefix + '-dialog-title]');
        var status = composer.querySelector('[data-' + prefix + '-status]');
        var svgDescription = composer.querySelector('[data-' + prefix + '-svg-description]');
        var stageSummary = atelier && atelier.querySelector('[data-mojo-stage-summary="fabric"]');
        var summaryInput = isDobby ? composer.querySelector('[data-dobby-summary-value]') : null;
        var swap = composer.querySelector('[data-' + prefix + '-swap]');
        var choices = Array.prototype.slice.call(composer.querySelectorAll('[data-' + prefix + '-choice]'));
        var openers = Array.prototype.slice.call(composer.querySelectorAll('[data-' + prefix + '-open]'));
        var closeButton = composer.querySelector('[data-' + prefix + '-close]');
        var activeRole = firstRole;
        var lastOpener = null;

        if (!firstSelect || !secondSelect || !dialog) return;

        function optionFor(select) {
          return select.selectedIndex > 0 ? select.options[select.selectedIndex] : null;
        }

        function compactLabel(option) {
          return option ? option.textContent.trim() : '';
        }

        function colourName(option) {
          return compactLabel(option).replace(/^\d+\s*·\s*/, '');
        }

        function syncWell(role, option, fallback) {
          var well = composer.querySelector('[data-' + prefix + '-well-swatch="' + role + '"]');
          var hex = option && option.getAttribute(hexAttribute) ? option.getAttribute(hexAttribute) : fallback;
          composer.style.setProperty('--mojo-' + prefix + '-' + role, hex);
          if (well) well.style.setProperty('--mojo-degrande-well', hex);
        }

        function sync() {
          var firstOption = optionFor(firstSelect);
          var secondOption = optionFor(secondSelect);
          var firstName = colourName(firstOption);
          var secondName = colourName(secondOption);
          var liveCopy = isDobby ? atelierCopy('dobbyIntro') : atelierCopy('degrandeIntro');

          syncWell(firstRole, firstOption, isDobby ? '#4c4f85' : '#ede5d8');
          syncWell(secondRole, secondOption, isDobby ? '#c99f7b' : '#b69b78');

          if (firstOption && secondOption) {
            liveCopy = isDobby
              ? atelierCopy('dobbyComplete', { first: firstName, second: secondName })
              : atelierCopy('degrandeComplete', { first: firstName, second: secondName });
            if (firstSelect.value === secondSelect.value) liveCopy += ' ' + atelierCopy('tonalSame');
          } else if (firstOption) {
            liveCopy = isDobby
              ? atelierCopy('dobbyFirst', { first: firstName })
              : atelierCopy('degrandeFirst', { first: firstName });
          } else if (secondOption) {
            liveCopy = isDobby
              ? atelierCopy('dobbySecond', { second: secondName })
              : atelierCopy('degrandeSecond', { second: secondName });
          }

          if (status) status.textContent = liveCopy;
          if (svgDescription) svgDescription.textContent = liveCopy;
          if (swap) swap.disabled = !(firstOption && secondOption);
          if (summaryInput) {
            summaryInput.value = firstOption && secondOption
              ? firstSelect.value + ' + sisi balik ' + secondSelect.value
              : '';
          }

          if (stageSummary) {
            if (firstOption && secondOption) {
              stageSummary.textContent = firstName + ' + ' + secondName;
            } else if (firstOption || secondOption) {
              stageSummary.textContent = atelierCopy('oneOfTwo');
            } else {
              stageSummary.textContent = atelierCopy('notSelected');
            }
          }
        }

        function markDialogSelection() {
          var target = activeRole === secondRole ? secondSelect : firstSelect;
          choices.forEach(function (choice) {
            choice.setAttribute('aria-pressed', choice.getAttribute(valueAttribute) === target.value ? 'true' : 'false');
          });
        }

        function openPalette(role, opener) {
          activeRole = role === secondRole ? secondRole : firstRole;
          lastOpener = opener;
          if (dialogTitle) {
            if (isDobby) {
              dialogTitle.textContent = activeRole === secondRole ? atelierCopy('chooseReverse') : atelierCopy('chooseMain');
            } else {
              dialogTitle.textContent = activeRole === secondRole ? atelierCopy('chooseDoubleList') : atelierCopy('choosePrimary');
            }
          }
          markDialogSelection();
          if (typeof dialog.showModal === 'function') {
            if (!dialog.open) dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
        }

        function closePalette() {
          if (typeof dialog.close === 'function' && dialog.open) {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        }

        openers.forEach(function (opener) {
          opener.addEventListener('click', function () {
            openPalette(opener.getAttribute(openAttribute), opener);
          });
        });

        choices.forEach(function (choice) {
          choice.addEventListener('click', function () {
            var target = activeRole === secondRole ? secondSelect : firstSelect;
            target.value = choice.getAttribute(valueAttribute);
            target.dispatchEvent(new Event('input', { bubbles: true }));
            target.dispatchEvent(new Event('change', { bubbles: true }));
            sync();
            closePalette();

            if (activeRole === firstRole && !secondSelect.value) {
              var secondOpener = openers.find(function (opener) { return opener.getAttribute(openAttribute) === secondRole; });
              if (secondOpener) window.setTimeout(function () { secondOpener.focus(); }, 0);
            }
          });
        });

        firstSelect.addEventListener('change', sync);
        secondSelect.addEventListener('change', sync);

        function containComposerSelection(event) {
          if (event.target !== firstSelect && event.target !== secondSelect) return;

          // These selects are line-item properties, not Shopify variant controls.
          // Keep their change events inside the composer so Prestige does not
          // interpret them as a variant change and return the atelier to step 01.
          event.stopPropagation();

          // The purchase dock still needs one contained signal to refresh its
          // completion state without leaking another change event to the product.
          if (atelier) atelier.dispatchEvent(new Event('input'));

          // Prestige observes product-field changes during capture, before this
          // composer can contain them. Restore the customer's active fabric step
          // after that synchronous observer finishes so mix-and-match stays open.
          window.setTimeout(function () {
            var fabricTrigger = atelier && atelier.querySelector('[data-mojo-stage-trigger="fabric"]');
            if (fabricTrigger) fabricTrigger.click();
          }, 0);
        }

        composer.addEventListener('input', containComposerSelection);
        composer.addEventListener('change', containComposerSelection);

        if (swap) {
          swap.addEventListener('click', function () {
            if (!firstSelect.value || !secondSelect.value) return;
            var firstValue = firstSelect.value;
            firstSelect.value = secondSelect.value;
            secondSelect.value = firstValue;
            firstSelect.dispatchEvent(new Event('change', { bubbles: true }));
            secondSelect.dispatchEvent(new Event('change', { bubbles: true }));
            sync();
          });
        }

        if (closeButton) closeButton.addEventListener('click', closePalette);
        dialog.addEventListener('close', function () {
          if (lastOpener && document.contains(lastOpener)) lastOpener.focus();
        });

        sync();
      });
    }

    function enhancePurchaseDocks(root) {
      root.querySelectorAll('[data-mojo-order-atelier]').forEach(function (atelier) {
        if (atelier.dataset.mojoPurchaseEnhanced === 'true') return;

        var dock = atelier.querySelector('[data-mojo-purchase-dock]');
        var action = dock && dock.querySelector('[data-mojo-purchase-action]');
        var status = dock && dock.querySelector('[data-mojo-purchase-status]');
        var mainProduct = document.querySelector('.shopify-section--main-product');
        var productForm = mainProduct && mainProduct.querySelector('form[action*="/cart/add"]');
        if (!dock || !action || !status || !productForm) return;

        atelier.dataset.mojoPurchaseEnhanced = 'true';

        function firstIncompleteField() {
          return Array.prototype.slice.call(atelier.querySelectorAll('[required]')).find(function (field) {
            return !field.checkValidity() || field.dataset.mojoMaternityValid === 'false';
          });
        }

        function syncDock() {
          var incomplete = firstIncompleteField();
          var selectedSet = atelier.querySelector('[data-mojo-set-choice]:checked');
          var selectedFabric = atelier.querySelector('[data-mojo-fabric-input]');
          var selectedDeGrandeBase = atelier.querySelector('[data-degrande-value="base"]');
          var selectedDeGrandeAccent = atelier.querySelector('[data-degrande-value="accent"]');
          var selectedDobbyPrimary = atelier.querySelector('[data-dobby-value="primary"]');
          var selectedDobbyReverse = atelier.querySelector('[data-dobby-value="reverse"]');

          dock.classList.toggle('is-complete', !incomplete);
          action.textContent = incomplete ? atelierCopy('reviewSelection') : atelierCopy('addToCart');

          if (incomplete) {
            status.textContent = atelierCopy('completeDetails');
          } else if (selectedFabric && selectedFabric.value) {
            status.textContent = selectedFabric.value.replace(/^.*? — /, '') + atelierCopy('readySuffix');
          } else if (selectedDeGrandeBase && selectedDeGrandeAccent && selectedDeGrandeBase.value && selectedDeGrandeAccent.value) {
            status.textContent = selectedDeGrandeBase.options[selectedDeGrandeBase.selectedIndex].textContent.replace(/^\d+\s*·\s*/, '') + ' + ' + selectedDeGrandeAccent.options[selectedDeGrandeAccent.selectedIndex].textContent.replace(/^\d+\s*·\s*/, '') + atelierCopy('readySuffix');
          } else if (selectedDobbyPrimary && selectedDobbyReverse && selectedDobbyPrimary.value && selectedDobbyReverse.value) {
            status.textContent = selectedDobbyPrimary.options[selectedDobbyPrimary.selectedIndex].textContent.replace(/^\d+\s*·\s*/, '') + ' + ' + selectedDobbyReverse.options[selectedDobbyReverse.selectedIndex].textContent.replace(/^\d+\s*·\s*/, '') + atelierCopy('readySuffix');
          } else if (selectedSet) {
            status.textContent = setDisplayLabel(selectedSet, true) + atelierCopy('readySuffix');
          } else {
            status.textContent = atelierCopy('selectionReady');
          }
        }

        action.addEventListener('click', function () {
          var incomplete = firstIncompleteField();

          if (incomplete) {
            var stagePanel = incomplete.closest('[data-mojo-stage-panel]');
            var stageName = stagePanel && stagePanel.dataset.mojoStagePanel;
            var trigger = stageName && atelier.querySelector('[data-mojo-stage-trigger="' + stageName + '"]');
            if (trigger) trigger.click();

            window.setTimeout(function () {
              incomplete.scrollIntoView({ behavior: 'smooth', block: 'center' });
              incomplete.reportValidity();
              if (typeof incomplete.focus === 'function') incomplete.focus({ preventScroll: true });
            }, 80);
            return;
          }

          var actualAdd = productForm.querySelector('button[type="submit"], input[type="submit"]');
          if (actualAdd && !actualAdd.disabled) {
            actualAdd.click();
          } else if (typeof productForm.requestSubmit === 'function') {
            productForm.requestSubmit();
          }
        });

        atelier.addEventListener('input', syncDock);
        atelier.addEventListener('change', syncDock);
        syncDock();

      });
    }

    function enhanceSpecialPriceSize(root) {
      root.querySelectorAll('[data-mojo-special-size]').forEach(function (select) {
        if (select.dataset.mojoSizeEnhanced === 'true') return;

        var mainProduct = document.querySelector('.shopify-section--main-product');
        var optionFields = mainProduct && Array.prototype.slice.call(mainProduct.querySelectorAll('.variant-picker__option'));
        var nativeField = optionFields && optionFields.find(function (field) {
          var legend = field.querySelector('legend');
          return legend && ['Jenis Ukuran', 'Size type'].indexOf(legend.textContent.trim().replace(/:$/, '')) !== -1;
        });
        var atelier = select.closest('[data-mojo-order-atelier]');
        var customPanel = atelier && atelier.querySelector('[data-mojo-custom-size]');
        var dimensions = customPanel ? Array.prototype.slice.call(customPanel.querySelectorAll('[data-mojo-custom-dimension]')) : [];

        select.dataset.mojoSizeEnhanced = 'true';
        if (nativeField) nativeField.classList.add('mojo-native-size-sync');

        function currentNativeInput(choice) {
          var currentFields = Array.prototype.slice.call(mainProduct.querySelectorAll('.variant-picker__option'));
          var currentField = currentFields.find(function (field) {
            var legend = field.querySelector('legend');
            return legend && ['Jenis Ukuran', 'Size type'].indexOf(legend.textContent.trim().replace(/:$/, '')) !== -1;
          });
          if (!currentField) return null;

          return Array.prototype.slice.call(currentField.querySelectorAll('input[type="radio"]')).find(function (input) {
            var label = input.closest('label');
            return label && label.textContent.trim() === choice;
          });
        }

        function syncSizeVariant() {
          var isCustom = select.value.indexOf('Custom') === 0;
          var target = nativeField ? currentNativeInput(isCustom ? 'Custom' : 'Standard') : null;

          if (customPanel) customPanel.hidden = !isCustom;
          dimensions.forEach(function (input) {
            input.disabled = !isCustom;
            input.required = isCustom;
            if (!isCustom) input.value = '';
          });

          if (select.value && target && !target.checked) target.click();
        }

        select.addEventListener('change', syncSizeVariant);
        syncSizeVariant();
      });
    }

    function enhanceLargeOptionPickers(root) {
      root.querySelectorAll('.variant-picker__option').forEach(function (fieldset) {
        if (fieldset.dataset.mojoEnhanced === 'true') return;

        var list = fieldset.querySelector('.variant-picker__option-values');
        if (!list) return;

        var choices = Array.prototype.slice.call(list.querySelectorAll('label'));
        var scopedPicker = fieldset.closest('variant-picker[context="main_product"]');
        var optionControl = choices[0] && (choices[0].control || (choices[0].htmlFor && document.getElementById(choices[0].htmlFor)));
        var jacquardMotif = scopedPicker && scopedPicker.getAttribute('handle') === 'mojokoe-sprei-bedcover-organic-jacquard-tencel-80s-bedding' && optionControl && optionControl.type === 'radio' && optionControl.getAttribute('data-option-position') === '1';
        if (choices.length < 25 && !(jacquardMotif && choices.length > 12)) return;

        fieldset.dataset.mojoEnhanced = 'true';
        fieldset.classList.add('mojo-many-options');

        choices.forEach(function (choice) {
          choice.dataset.mojoLabel = choice.textContent.trim().toLocaleLowerCase('id-ID');
        });

        var tools = document.createElement('div');
        tools.className = 'mojo-option-tools';
        var searchLabel = document.createElement('label');
        searchLabel.className = 'mojo-option-search';
        var searchText = document.createElement('span');
        searchText.className = 'sr-only';
        searchText.textContent = atelierCopy('motifSearch');
        var searchInput = document.createElement('input');
        searchInput.type = 'search';
        searchInput.inputMode = 'search';
        searchInput.autocomplete = 'off';
        searchInput.placeholder = atelierCopy('motifPlaceholder');
        var motifPicker = fieldset.closest('variant-picker[context="main_product"]');
        var motifPlaceholderHandles = [
          'mojokoe-big-sale-organic-lyocell-tencel-bedcover-quiltcover-set',
          'mojokoe-sprei-bedcover-organic-jacquard-tencel-80s-bedding',
          'mojokoe-sprei-bedcover-organic-lyocell-tencel-100s-bedding'
        ];
        if (motifPicker && motifPlaceholderHandles.indexOf(motifPicker.getAttribute('handle')) !== -1) {
          searchInput.placeholder = searchInput.placeholder.replace('MATUTE', choices[0].textContent.trim());
        }
        var count = document.createElement('span');
        count.className = 'mojo-option-count';
        count.setAttribute('aria-live', 'polite');
        searchLabel.appendChild(searchText);
        searchLabel.appendChild(searchInput);
        tools.appendChild(searchLabel);
        tools.appendChild(count);

        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'mojo-option-toggle';

        fieldset.querySelector('.variant-picker__option-info').insertAdjacentElement('afterend', tools);
        list.insertAdjacentElement('afterend', toggle);

        var input = searchInput;
        var counter = count;
        var expanded = false;

        function renderChoices() {
          var query = input.value.trim().toLocaleLowerCase('id-ID');
          var visibleCount = 0;

          choices.forEach(function (choice, index) {
            var control = choice.control || (choice.htmlFor && document.getElementById(choice.htmlFor));
            var selected = Boolean(control && control.type === 'radio' && control.checked);
            var match = query === '' || choice.dataset.mojoLabel.indexOf(query) !== -1;
            var visible = query !== '' ? match : (expanded || index < 12 || selected);
            choice.hidden = !visible;
            if (visible) visibleCount += 1;
          });

          counter.textContent = query
            ? atelierCopy('motifsFound', { count: visibleCount })
            : atelierCopy('motifsAvailable', { count: choices.length });
          toggle.hidden = query !== '';
          toggle.textContent = expanded
            ? atelierCopy('showLess')
            : atelierCopy('viewAllMotifs', { count: choices.length });
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }

        input.addEventListener('input', renderChoices);
        toggle.addEventListener('click', function () {
          expanded = !expanded;
          renderChoices();
          if (!expanded) fieldset.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });

        renderChoices();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        mountOrderAtelier(document);
        enhanceAtelierSteps(document);
        enhanceSetComposers(document);
        enhanceFabricAtlases(document);
        enhanceDeGrandeComposers(document);
        enhanceSpecialPriceSize(document);
        enhancePurchaseDocks(document);
        enhanceLargeOptionPickers(document);
      });
    } else {
      mountOrderAtelier(document);
      enhanceAtelierSteps(document);
      enhanceSetComposers(document);
      enhanceFabricAtlases(document);
      enhanceDeGrandeComposers(document);
      enhanceSpecialPriceSize(document);
      enhancePurchaseDocks(document);
      enhanceLargeOptionPickers(document);
    }

    document.addEventListener('variant:change', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      var section = form.closest('.shopify-section');
      if (!section) return;
      var picker = section.querySelector('variant-picker[context="main_product"]');
      if (!picker || picker.getAttribute('form-id') !== form.getAttribute('id')) return;
      var motifHandles = [
        'mojokoe-big-sale-organic-lyocell-tencel-bedcover-quiltcover-set',
        'mojokoe-sprei-bedcover-organic-jacquard-tencel-80s-bedding',
        'mojokoe-sprei-bedcover-organic-lyocell-tencel-100s-bedding'
      ];
      if (motifHandles.indexOf(picker.getAttribute('handle')) === -1) return;
      enhanceLargeOptionPickers(picker);
    });

    document.addEventListener('shopify:section:load', function (event) {
      mountOrderAtelier(event.target);
      enhanceAtelierSteps(event.target);
      enhanceSetComposers(event.target);
      enhanceFabricAtlases(event.target);
      enhanceDeGrandeComposers(event.target);
      enhanceSpecialPriceSize(event.target);
      enhancePurchaseDocks(event.target);
      enhanceLargeOptionPickers(event.target);
    });

    // Prestige already emits `shopify:section:load` when the editor replaces a
    // product section. A subtree-wide MutationObserver is intentionally avoided
    // here: product media and third-party widgets mutate continuously and can
    // otherwise keep re-running the Atelier enhancement pipeline.
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojokoe-editorial-navigation"]) return;
  try {
    
  if (!customElements.get('mojokoe-editorial-nav')) {
    customElements.define('mojokoe-editorial-nav', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized || Number(this.dataset.menuCount) < 1) return;
        this.initialized = true;
        this.dialog = this.querySelector('[data-mobile-dialog]');
        this.fallbackTrigger = this.querySelector('[data-mobile-fallback]');
        this.desktopBackdrop = this.querySelector('[data-desktop-backdrop]');
        this.disclosures = Array.from(this.querySelectorAll('[data-desktop-disclosure]'));
        this.mobileNativeTriggers = [];
        this.nativeDesktopBindings = [];
        this.nativeDesktopBindingByTrigger = new Map();
        this.originalTriggerAttributes = new Map();
        this.lastTrigger = null;
        this.lastDesktopTrigger = null;
        this.activePanel = 'root';
        this.closeTimer = null;
        this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.mobileViewport = window.matchMedia('(max-width: 999px)');
        this.onDocumentPointerDown = this.handleDocumentPointerDown.bind(this);
        this.onDocumentKeyDown = this.handleDocumentKeyDown.bind(this);
        this.onDialogClick = this.handleDialogClick.bind(this);
        this.onNativeTriggerClick = this.handleNativeTriggerClick.bind(this);
        this.onNativeDesktopClick = this.handleNativeDesktopClick.bind(this);
        this.onNativeDesktopPointerEnter = this.handleNativeDesktopPointerEnter.bind(this);
        this.onNativeDesktopPointerLeave = this.handleNativeDesktopPointerLeave.bind(this);
        this.onNativeDesktopFocus = this.handleNativeDesktopFocus.bind(this);
        this.onDesktopToggle = this.handleDesktopToggle.bind(this);
        this.onDesktopPointerEnter = this.handleDesktopPointerEnter.bind(this);
        this.onDesktopPointerLeave = this.handleDesktopPointerLeave.bind(this);
        this.onDesktopBackdropClick = () => this.closeDesktop();
        this.onGeometryChange = () => this.syncHeaderOffset();

        document.documentElement.classList.add('mojo-editorial-nav-ready');
        this.bindDesktop();
        this.bindMobile();
        this.syncHeaderOffset();
        window.addEventListener('resize', this.onGeometryChange, { passive: true });
        window.addEventListener('scroll', this.onGeometryChange, { passive: true });
      }

      disconnectedCallback() {
        if (!this.initialized) return;
        document.removeEventListener('pointerdown', this.onDocumentPointerDown);
        document.removeEventListener('keydown', this.onDocumentKeyDown);
        window.removeEventListener('resize', this.onGeometryChange);
        window.removeEventListener('scroll', this.onGeometryChange);
        this.dialog?.removeEventListener('click', this.onDialogClick);
        this.desktopBackdrop?.removeEventListener('click', this.onDesktopBackdropClick);
        this.mobileNativeTriggers.forEach((trigger) => {
          trigger.removeEventListener('click', this.onNativeTriggerClick, true);
          this.restoreTriggerAttributes(trigger);
        });
        this.nativeDesktopBindings.forEach(({ trigger, nativeDetails }) => {
          trigger.removeEventListener('click', this.onNativeDesktopClick, true);
          trigger.removeEventListener('pointerenter', this.onNativeDesktopPointerEnter);
          trigger.removeEventListener('pointerleave', this.onNativeDesktopPointerLeave);
          trigger.removeEventListener('focusin', this.onNativeDesktopFocus);
          trigger.classList.remove('mojo-native-menu-trigger');
          nativeDetails?.classList.remove('mojo-native-menu-details');
          this.restoreTriggerAttributes(trigger);
        });
        this.disclosures.forEach((disclosure) => {
          disclosure.removeEventListener('toggle', this.onDesktopToggle);
          disclosure.removeEventListener('pointerenter', this.onDesktopPointerEnter);
          disclosure.removeEventListener('pointerleave', this.onDesktopPointerLeave);
        });
        window.clearTimeout(this.closeTimer);
        document.documentElement.classList.remove('mojo-mega-menu-open', 'mojo-mobile-menu-open');
        if (!document.querySelector('mojokoe-editorial-nav[data-menu-count]:not([data-menu-count="0"])')) {
          document.documentElement.classList.remove('mojo-editorial-nav-ready');
        }
      }

      bindDesktop() {
        this.disclosures.forEach((disclosure) => {
          disclosure.addEventListener('toggle', this.onDesktopToggle);
          disclosure.addEventListener('pointerenter', this.onDesktopPointerEnter);
          disclosure.addEventListener('pointerleave', this.onDesktopPointerLeave);
        });
        this.desktopBackdrop?.addEventListener('click', this.onDesktopBackdropClick);

        const primaryNav = document.querySelector('.header__primary-nav');
        const nativeSummaries = primaryNav ? Array.from(primaryNav.querySelectorAll('summary[data-title]')) : [];

        nativeSummaries.forEach((trigger) => {
          const menuKey = this.toMenuKey(trigger.dataset.title || trigger.textContent);
          const disclosure = this.disclosures.find((candidate) => candidate.dataset.menuKey === menuKey);
          if (!disclosure) return;

          const panel = disclosure.querySelector('.mojo-editorial-nav__mega');
          const nativeDetails = trigger.closest('details');
          this.rememberTriggerAttributes(trigger);
          trigger.classList.add('mojo-native-menu-trigger');
          nativeDetails?.classList.add('mojo-native-menu-details');
          trigger.setAttribute('aria-controls', panel?.id || '');
          trigger.setAttribute('aria-expanded', 'false');

          const binding = { trigger, disclosure, nativeDetails };
          this.nativeDesktopBindings.push(binding);
          this.nativeDesktopBindingByTrigger.set(trigger, binding);
          trigger.addEventListener('click', this.onNativeDesktopClick, true);
          trigger.addEventListener('pointerenter', this.onNativeDesktopPointerEnter);
          trigger.addEventListener('pointerleave', this.onNativeDesktopPointerLeave);
          trigger.addEventListener('focusin', this.onNativeDesktopFocus);
        });

        document.addEventListener('pointerdown', this.onDocumentPointerDown);
        document.addEventListener('keydown', this.onDocumentKeyDown);
      }

      bindMobile() {
        if (!this.dialog) return;
        const nativeSelector = [
          '[aria-controls="sidebar-menu"]',
          '[aria-controls="header-sidebar-menu"]',
          '[aria-controls*="header-sidebar"]',
          '.header__icon-list button[aria-label*="menu" i]'
        ].join(',');
        this.mobileNativeTriggers = Array.from(document.querySelectorAll(nativeSelector)).filter((trigger) => !this.contains(trigger));

        this.mobileNativeTriggers.forEach((trigger) => {
          this.rememberTriggerAttributes(trigger);
          trigger.setAttribute('aria-controls', this.dialog.id);
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.addEventListener('click', this.onNativeTriggerClick, true);
        });

        this.dialog.addEventListener('click', this.onDialogClick);
      }

      rememberTriggerAttributes(trigger) {
        if (this.originalTriggerAttributes.has(trigger)) return;
        this.originalTriggerAttributes.set(trigger, {
          controls: trigger.getAttribute('aria-controls'),
          expanded: trigger.getAttribute('aria-expanded'),
          haspopup: trigger.getAttribute('aria-haspopup')
        });
      }

      restoreTriggerAttributes(trigger) {
        const original = this.originalTriggerAttributes.get(trigger);
        if (!original) return;
        ['controls', 'expanded', 'haspopup'].forEach((name) => {
          const value = original[name];
          const attribute = `aria-${name}`;
          if (value == null) trigger.removeAttribute(attribute);
          else trigger.setAttribute(attribute, value);
        });
      }

      toMenuKey(value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '');
      }

      syncHeaderOffset() {
        const header = document.querySelector('.shopify-section--header');
        if (!header) return;
        const rect = header.getBoundingClientRect();
        const bottom = Math.max(0, Math.min(window.innerHeight, rect.bottom));
        this.style.setProperty('--mojo-menu-top', `${Math.round(bottom)}px`);
      }

      handleDesktopToggle(event) {
        const current = event.currentTarget;
        if (current.open) {
          this.disclosures.forEach((disclosure) => {
            if (disclosure !== current) disclosure.open = false;
          });
        }

        const openDisclosure = this.disclosures.find((disclosure) => disclosure.open);
        const isOpen = Boolean(openDisclosure);
        this.classList.toggle('is-desktop-open', isOpen);
        document.documentElement.classList.toggle('mojo-mega-menu-open', isOpen);
        this.desktopBackdrop?.setAttribute('aria-hidden', String(!isOpen));
        this.nativeDesktopBindings.forEach(({ trigger, disclosure }) => {
          trigger.setAttribute('aria-expanded', String(disclosure === openDisclosure));
        });
        this.syncHeaderOffset();
      }

      openDesktop(disclosure, trigger) {
        if (!disclosure || this.mobileViewport.matches) return;
        window.clearTimeout(this.closeTimer);
        this.lastDesktopTrigger = trigger || this.lastDesktopTrigger;
        this.nativeDesktopBindings.forEach(({ nativeDetails }) => {
          if (nativeDetails) nativeDetails.open = false;
        });
        this.disclosures.forEach((candidate) => {
          candidate.open = candidate === disclosure;
        });
        this.syncHeaderOffset();
      }

      closeDesktop(returnFocus = false) {
        window.clearTimeout(this.closeTimer);
        this.disclosures.forEach((disclosure) => {
          disclosure.open = false;
        });
        if (returnFocus) this.lastDesktopTrigger?.focus?.();
      }

      scheduleDesktopClose() {
        window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(() => this.closeDesktop(), 220);
      }

      handleDesktopPointerEnter(event) {
        if (!this.finePointer.matches || this.mobileViewport.matches) return;
        window.clearTimeout(this.closeTimer);
        if (!event.currentTarget.open) event.currentTarget.open = true;
      }

      handleDesktopPointerLeave() {
        if (!this.finePointer.matches || this.mobileViewport.matches) return;
        this.scheduleDesktopClose();
      }

      handleNativeDesktopClick(event) {
        if (this.mobileViewport.matches) return;
        const binding = this.nativeDesktopBindingByTrigger.get(event.currentTarget);
        if (!binding) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (binding.disclosure.open) {
          if (event.detail === 0) return;
          this.closeDesktop();
        } else {
          this.openDesktop(binding.disclosure, binding.trigger);
        }
      }

      handleNativeDesktopPointerEnter(event) {
        if (!this.finePointer.matches || this.mobileViewport.matches) return;
        const binding = this.nativeDesktopBindingByTrigger.get(event.currentTarget);
        if (binding) this.openDesktop(binding.disclosure, binding.trigger);
      }

      handleNativeDesktopPointerLeave() {
        if (!this.finePointer.matches || this.mobileViewport.matches) return;
        this.scheduleDesktopClose();
      }

      handleNativeDesktopFocus(event) {
        if (this.mobileViewport.matches) return;
        const binding = this.nativeDesktopBindingByTrigger.get(event.currentTarget);
        if (binding) this.openDesktop(binding.disclosure, binding.trigger);
      }

      handleDocumentPointerDown(event) {
        if (this.mobileViewport.matches || this.contains(event.target)) return;
        if (this.nativeDesktopBindings.some(({ trigger }) => trigger.contains(event.target))) return;
        this.closeDesktop();
      }

      handleDocumentKeyDown(event) {
        if (event.key !== 'Escape') return;
        if (this.dialog?.open) {
          event.preventDefault();
          this.closeMobile();
          return;
        }
        if (this.disclosures.some((disclosure) => disclosure.open)) {
          event.preventDefault();
          this.closeDesktop(true);
        }
      }

      handleNativeTriggerClick(event) {
        if (!this.mobileViewport.matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.openMobile(event.currentTarget);
      }

      handleDialogClick(event) {
        const closeButton = event.target.closest('[data-mobile-close]');
        const openButton = event.target.closest('[data-mobile-open]');
        const backButton = event.target.closest('[data-mobile-back]');

        if (closeButton) {
          this.closeMobile();
          return;
        }
        if (openButton) {
          this.showPanel(openButton.dataset.mobileOpen, false);
          return;
        }
        if (backButton) {
          this.showPanel(backButton.dataset.mobileBack, true);
          return;
        }
        if (event.target === this.dialog) this.closeMobile();
      }

      openMobile(trigger) {
        if (!this.dialog || this.dialog.open) return;
        this.closeDesktop();
        this.lastTrigger = trigger || document.activeElement;
        this.showPanel('root', true, false);
        this.mobileNativeTriggers.forEach((nativeTrigger) => nativeTrigger.setAttribute('aria-expanded', 'true'));
        document.documentElement.classList.add('mojo-mobile-menu-open');
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
        window.requestAnimationFrame(() => this.dialog.querySelector('[data-mobile-close]')?.focus());
      }

      closeMobile() {
        if (!this.dialog?.open || this.dialog.classList.contains('is-closing')) return;
        this.dialog.classList.add('is-closing');
        window.setTimeout(() => {
          this.dialog.classList.remove('is-closing');
          this.dialog.close();
          this.mobileNativeTriggers.forEach((nativeTrigger) => nativeTrigger.setAttribute('aria-expanded', 'false'));
          document.documentElement.classList.remove('mojo-mobile-menu-open');
          this.lastTrigger?.focus?.();
        }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 240);
      }

      showPanel(panelName, backwards = false, animate = true) {
        const nextPanel = this.querySelector(`[data-mobile-panel="${CSS.escape(panelName)}"]`);
        if (!nextPanel) return;
        this.querySelectorAll('[data-mobile-open]').forEach((button) => {
          button.setAttribute('aria-expanded', String(button.dataset.mobileOpen === panelName));
        });
        this.querySelectorAll('[data-mobile-panel]').forEach((panel) => {
          panel.hidden = panel !== nextPanel;
          panel.classList.remove('is-entering-forward', 'is-entering-back');
        });
        nextPanel.hidden = false;
        if (animate) {
          nextPanel.classList.add(backwards ? 'is-entering-back' : 'is-entering-forward');
          window.setTimeout(() => nextPanel.classList.remove('is-entering-forward', 'is-entering-back'), 320);
        }
        nextPanel.scrollTop = 0;
        this.dialog.scrollTop = 0;
        this.activePanel = panelName;
        window.requestAnimationFrame(() => {
          const focusTarget = nextPanel.querySelector('[data-mobile-back], button, a');
          focusTarget?.focus();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojokoe-kids-dreamworld"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pingo-star-game')) {
    customElements.define(
      'pingo-star-game',
      class PingoStarGame extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;

          this.dataset.ready = 'true';
          this.startButton = this.querySelector('[data-game-start]');
          this.playArea = this.querySelector('[data-game-play]');
          this.progress = this.querySelector('[data-game-progress]');
          this.progressText = this.querySelector('[data-game-progress-text]');
          this.status = this.querySelector('[data-game-status]');
          this.finish = this.querySelector('[data-game-finish]');
          this.resetButton = this.querySelector('[data-game-reset]');
          this.stars = Array.from(this.querySelectorAll('[data-game-star]'));
          this.slots = Array.from(this.querySelectorAll('[data-game-slot]'));
          this.count = 0;

          this.startButton?.addEventListener('click', () => this.start());
          this.resetButton?.addEventListener('click', () => this.reset());
          this.stars.forEach((star) => {
            star.addEventListener('click', () => this.placeStar(star));
          });
        }

        start() {
          this.startButton.closest('.pingo-star-game__cover').hidden = true;
          this.playArea.hidden = false;
          this.reset();
          this.stars[0]?.focus();
        }

        placeStar(star) {
          if (star.disabled || this.count >= this.slots.length) return;

          star.disabled = true;
          this.slots[this.count]?.classList.add('is-filled');
          this.count += 1;
          this.progress.value = this.count;
          this.progress.textContent = `${this.count}/5`;
          this.progressText.textContent = `${this.count} / 5`;

          if (this.count === this.slots.length) {
            this.status.textContent = this.dataset.completeMessage;
            this.finish.hidden = false;
            this.finish.querySelector('h3')?.focus();
            return;
          }

          this.status.textContent = `${this.count} ${this.dataset.progressMessage}`;
          this.stars.find((candidate) => !candidate.disabled)?.focus();
        }

        reset() {
          this.count = 0;
          this.progress.value = 0;
          this.progress.textContent = '0/5';
          this.progressText.textContent = '0 / 5';
          this.finish.hidden = true;
          this.stars.forEach((star) => {
            star.disabled = false;
          });
          this.slots.forEach((slot) => {
            slot.classList.remove('is-filled');
          });
          this.status.textContent = this.dataset.readyMessage;
          this.stars[0]?.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojokoe-okendo-apps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const namespace = 'MojokoeOkendoEnhancer';
    const version = 'premium-pdp-compact-list-v4';
    const starBlockSelector = ".product-info__block-item[data-block-type='@app']:has(.okeReviews.oke-sr)";
    const starInteractiveSelector = ".okeReviews.oke-sr > .oke-is-clickable[role='button'][tabindex='0']";
    const starTriggerSelector = starBlockSelector + ' ' + starInteractiveSelector;
    const surfaceSelector = '[data-mojokoe-okendo-surface]';
    const headingSelector = '.mojokoe-okendo-heading';
    const existing = window[namespace];

    if (existing?.version === version && existing.diagnostics?.().active) return;
    existing?.teardown?.();

    const activeSurfaces = new Set(document.querySelectorAll(surfaceSelector));
    if (activeSurfaces.size === 0) return;

    const controller = new AbortController();
    const { signal } = controller;
    let active = true;
    let pendingFocusFrame = 0;
    let completedFocusCount = 0;
    let api = null;

    const enhancedReviewLists = new Map();

    const restoreListAttributes = (list, attributes) => {
      for (const [name, value] of attributes) {
        if (list.getAttribute(name) === value) list.removeAttribute(name);
      }
    };

    const enhanceReviewLists = () => {
      if (!active) return;
      for (const [list, attributes] of enhancedReviewLists) {
        const stillOwned = [...activeSurfaces].some((surface) =>
          surface.isConnected && surface.contains(list)
        );
        if (!stillOwned) {
          restoreListAttributes(list, attributes);
          enhancedReviewLists.delete(list);
        }
      }
      for (const surface of activeSurfaces) {
        if (!surface.isConnected) continue;
        const heading = surface.querySelector(headingSelector);
        if (!heading?.id) continue;
        for (const list of surface.querySelectorAll('.oke-w-reviews-list')) {
          const attributes = enhancedReviewLists.get(list) || new Map();
          if (!list.hasAttribute('tabindex')) {
            list.setAttribute('tabindex', '0');
            attributes.set('tabindex', '0');
          }
          if (!list.hasAttribute('aria-labelledby') && !list.hasAttribute('aria-label')) {
            list.setAttribute('aria-labelledby', heading.id);
            attributes.set('aria-labelledby', heading.id);
          }
          if (attributes.size) enhancedReviewLists.set(list, attributes);
        }
      }
    };

    const reviewListObserver = new MutationObserver(enhanceReviewLists);
    const observeReviewSurfaces = () => {
      reviewListObserver.disconnect();
      for (const surface of activeSurfaces) {
        if (surface.isConnected) {
          reviewListObserver.observe(surface, { childList: true, subtree: true });
        }
      }
      enhanceReviewLists();
    };

    const collectSurfaces = (root) => {
      if (!(root instanceof Element)) return [];
      return [
        ...(root.matches(surfaceSelector) ? [root] : []),
        ...root.querySelectorAll(surfaceSelector)
      ];
    };

    const getActiveSurface = () => {
      for (const surface of activeSurfaces) {
        if (surface.isConnected) return surface;
        activeSurfaces.delete(surface);
      }
      return null;
    };

    const teardown = () => {
      if (!active) return;
      active = false;
      if (pendingFocusFrame) cancelAnimationFrame(pendingFocusFrame);
      pendingFocusFrame = 0;
      reviewListObserver.disconnect();
      for (const [list, attributes] of enhancedReviewLists) restoreListAttributes(list, attributes);
      enhancedReviewLists.clear();
      activeSurfaces.clear();
      controller.abort();
      if (window[namespace] === api) delete window[namespace];
    };

    const resolveReviewHeading = (target) => {
      if (!(target instanceof Element) || !target.closest(starTriggerSelector)) return null;
      const surface = getActiveSurface();
      if (!surface) {
        teardown();
        return null;
      }
      const heading = surface.querySelector(headingSelector);
      return heading ? { surface, heading } : null;
    };

    const queueReviewHeadingFocus = ({ surface, heading }) => {
      if (pendingFocusFrame) cancelAnimationFrame(pendingFocusFrame);
      pendingFocusFrame = requestAnimationFrame(() => {
        pendingFocusFrame = 0;
        if (signal.aborted || !surface.isConnected || getActiveSurface() !== surface) return;
        const activeHeading = surface.querySelector(headingSelector);
        if (activeHeading !== heading) return;
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({
          block: 'start',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        completedFocusCount += 1;
      });
    };

    const suppressProviderNavigation = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    const ownStarActivation = (event, scheduleFocus = true) => {
      const resolved = resolveReviewHeading(event.target);
      if (!resolved) return false;
      suppressProviderNavigation(event);
      if (scheduleFocus) queueReviewHeadingFocus(resolved);
      return true;
    };

    const handleDocumentClick = (event) => {
      ownStarActivation(event);
    };

    const handleDocumentKeydown = (event) => {
      if (event.isComposing || (event.key !== 'Enter' && event.key !== ' ')) return;
      ownStarActivation(event, !event.repeat);
    };

    const handleSectionLoad = (event) => {
      collectSurfaces(event.target).forEach((surface) => activeSurfaces.add(surface));
      observeReviewSurfaces();
    };

    const handleSectionUnload = (event) => {
      collectSurfaces(event.target).forEach((surface) => activeSurfaces.delete(surface));
      if (activeSurfaces.size === 0) teardown();
      else observeReviewSurfaces();
    };

    const diagnostics = () => ({
      active,
      controllerAborted: signal.aborted,
      activeSurfaceCount: activeSurfaces.size,
      pendingFocus: Boolean(pendingFocusFrame),
      completedFocusCount,
      enhancedReviewListCount: enhancedReviewLists.size
    });

    document.addEventListener('click', handleDocumentClick, { capture: true, signal });
    document.addEventListener('keydown', handleDocumentKeydown, { capture: true, signal });
    document.addEventListener('shopify:section:load', handleSectionLoad, { signal });
    document.addEventListener('shopify:section:unload', handleSectionUnload, { signal });
    api = { version, diagnostics, teardown };
    window[namespace] = api;
    observeReviewSurfaces();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojokoe-shopping-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mojokoe-shopping-guide')) {
    customElements.define('mojokoe-shopping-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.frame = this.querySelector('.msg-frame');
        this.poster = this.querySelector('.msg-poster');
        this.start = this.querySelector('.msg-start');
        this.introStart = this.querySelector('.msg-film-intro');
        this.error = this.querySelector('.msg-error');
        this.mediaQuery = matchMedia('(max-width: 799px)');
        this.onResize = () => this.resetPlayer();
        this.onStart = () => this.startPlayer();
        this.onIntroStart = () => { this.startPlayer(); this.frame.scrollIntoView({block:'center', behavior:'auto'}); };
        this.mediaQuery.addEventListener('change', this.onResize);
        this.start.addEventListener('click', this.onStart);
        this.introStart.addEventListener('click', this.onIntroStart);
      }
      disconnectedCallback() {
        this.resetPlayer();
        this.mediaQuery?.removeEventListener('change', this.onResize);
        this.start?.removeEventListener('click', this.onStart);
        this.introStart?.removeEventListener('click', this.onIntroStart);
        this.bound = false;
      }
      resetPlayer() {
        if (this.video) { this.video.pause(); this.video.removeAttribute('src'); this.video.load(); this.video.remove(); this.video = null; }
        if (this.poster) this.poster.hidden = false;
        if (this.start) this.start.hidden = false;
        if (this.error) this.error.hidden = true;
      }
      startPlayer() {
        if (this.video) {
          this.video.focus({preventScroll:true});
          this.video.play().catch((error) => {
            if (error.name !== 'AbortError') {
              this.error.querySelector('a').href = this.video.currentSrc || this.video.src;
              this.error.hidden = false;
            }
          });
          return;
        }
        const src = this.mediaQuery.matches ? this.dataset.mobileSrc : this.dataset.desktopSrc;
        if (!src) { this.error.hidden = false; return; }
        const video = document.createElement('video');
        video.controls = true;
        video.playsInline = true;
        video.preload = 'none';
        video.crossOrigin = 'anonymous';
        video.tabIndex = 0;
        video.poster = this.poster.querySelector('img')?.currentSrc || '';
        video.src = src;
        video.setAttribute('aria-label', this.dataset.videoLabel);
        for (const [code, label, url] of [['id','Bahasa Indonesia',this.dataset.captionsId],['en','English',this.dataset.captionsEn]]) {
          if (!url) continue;
          const track = document.createElement('track');
          track.kind = 'subtitles'; track.srclang = code; track.label = label; track.src = url;
          video.append(track);
        }
        video.addEventListener('loadedmetadata', () => { for (const track of video.textTracks) track.mode = 'disabled'; }, {once:true});
        const onError = () => { this.error.querySelector('a').href = src; this.error.hidden = false; };
        video.addEventListener('error', onError);
        video.addEventListener('playing', () => { this.error.hidden = true; });
        this.video = video;
        this.frame.append(video);
        this.poster.hidden = true;
        this.start.hidden = true;
        video.focus({preventScroll:true});
        video.play().catch((error) => { if (error.name !== 'AbortError') onError(); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
